import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricingIncludes } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
export function Pricing() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="pricing" className="w-full bg-neutral-100 px-5 py-16 sm:px-8" data-id="element-188" data-mp="2jk5xyzxw9to4">
      <div className="mx-auto w-full max-w-xl" data-id="element-189" data-mp="1vv37d2la8qhh">
        <div className="flex justify-center" data-id="element-190" data-mp="1vvv2kcaywm78">
          <p className="rounded-full bg-ember-soft px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-ember-deep" data-id="element-191" data-mp="1rthydsbvcwck">
            Limited-time offer
          </p>
        </div>

        <h2 className="mt-5 text-center text-3xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-4xl" data-id="element-192" data-mp="20sv7ukzztkxa">
          Everything included, <span className="text-ember" data-id="element-193" data-mp="3h9hejtdwnm1p">one single price.</span>
        </h2>
        <p className="mt-4 text-center text-sm font-bold text-neutral-700" data-id="element-194" data-mp="3c7ibylpzot5t">
          Complete package. No upsells. No surprises.
        </p>

        <div className="relative mt-10 overflow-hidden rounded-3xl border border-neutral-200 bg-white shadow-sm" data-id="element-195" data-mp="4t5mxgphvg05">
          <div className="h-1.5 w-full bg-ember" data-id="element-196" data-mp="9siay4s3qt4b" />
          <div className="flex justify-center" data-id="element-197" data-mp="9t0d1i1g41k5">
            <p className="rounded-b-xl bg-ember px-5 py-2 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-198" data-mp="erv5zct4n6hz">
              🏆 Complete offer
            </p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-199" data-mp="3i7si3raumoiy">
            <h3 className="text-center text-xl font-extrabold uppercase leading-snug tracking-tight text-neutral-900 sm:text-2xl" data-id="element-200" data-mp="3i8tr7q8b10y1">
              Basketball Ready 360 + Pro Tactical Kit
            </h3>
            <p className="mt-3 text-center text-sm font-semibold text-neutral-700" data-id="element-201" data-mp="3rzeq7erw47hh">
              6 Volumes + 5 Bonuses + Pro Tactical Kit
            </p>

            <p className="mt-7 text-center text-xs font-semibold text-neutral-500" data-id="element-202" data-mp="2zhapdmq0nsxl">
              Total value: <span className="line-through" data-id="element-203" data-mp="2rgl6dghfp73a">$90</span>
            </p>

            <div className="mt-2 flex items-end justify-center gap-1" data-id="element-204" data-mp="2rei9cchv6dp2">
              <span className="mb-3 text-2xl font-extrabold text-neutral-900" data-id="element-205" data-mp="2mh8nf6took5z">$</span>
              <span className="text-7xl font-extrabold leading-none tracking-tight text-neutral-900" data-id="element-206" data-mp="315cwdj2xphbk">
                27
              </span>
              <span className="mb-2 ml-1 text-sm font-semibold text-neutral-600" data-id="element-207" data-mp="2w9xl8ywb9ziu">
                one-time
              </span>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-208" data-mp="23jz37ngjb2no">
              <span className="rounded-full bg-grass px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-209" data-mp="2igpv7bnvpc39">
                Save $63
              </span>
              <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-neutral-600" data-id="element-210" data-mp="3tvbpbpk91yli">
                Lifetime access
              </span>
            </div>

            <hr className="my-8 border-neutral-200" data-id="element-211" data-mp="3ovz1p2lk0nhv" />

            <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-neutral-900" data-id="element-212" data-mp="a43jr86kuox">
              What's included
            </p>
            <ul className="mx-auto mt-5 grid gap-3 sm:grid-cols-2" data-id="element-213" data-mp="57409bj54l3d">
              {pricingIncludes.map(item => <li key={item} className="flex items-center gap-2" data-id="element-214" data-mp="3rgeyr6qif18c">
                  <span aria-hidden="true" className="text-sm" data-id="element-215" data-mp="3rirfjgkj75jt">
                    ✅
                  </span>
                  <span className="text-sm font-semibold text-neutral-900" data-id="element-216" data-mp="j37qyuut2bb3">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-4 rounded-xl border border-neutral-200 bg-neutral-50 px-5 py-4" data-id="element-217" data-mp="a9cuscbnvv7l">
              <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.1em] text-neutral-700" data-id="element-218" data-mp="e825ty9890o2">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="16qfxfg3yzqep" />
                Ends in
              </span>
              <span className="text-center" data-id="element-220" data-mp="3f81qsr9pewm8">
                <span className="block text-sm font-extrabold tabular-nums text-ember" data-id="element-221" data-mp="3f93cdpocj1i7">
                  {hours}:{minutes}:{seconds}
                </span>
                <span className="block text-[9px] font-bold uppercase tracking-[0.18em] text-neutral-500" data-id="element-222" data-mp="358t1ibpsa667">
                  HRS MIN SEC
                </span>
              </span>
            </div>

            <div className="mt-6" data-id="element-223" data-mp="1t5e7hhdep9c">
              <CtaButton href="https://basketball-ready-360.impultienda.ar/checkout" data-id="element-224" data-mp="1s453ijx0cu9" />
            </div>

            <p className="mt-4 text-center text-xs font-semibold text-neutral-600" data-id="element-225" data-mp="3szgjxqxbse70">
              🛡️ Backed by our 7-day money-back guarantee
            </p>

            <hr className="my-7 border-neutral-200" data-id="element-226" data-mp="3k74v29hv0yt5" />

            <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-neutral-700" data-id="element-227" data-mp="3k4ipugifyve3">
              <li className="flex items-center gap-1.5" data-id="element-228" data-mp="fsn8gcdfquq3">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-229" data-mp="fr3rsknvahns" /> Secure Payment
              </li>
              <li className="flex items-center gap-1.5" data-id="element-230" data-mp="1ygzojym60q7b">
                <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-231" data-mp="23dgbiphmoyit" /> Instant Access
              </li>
              <li className="flex items-center gap-1.5" data-id="element-232" data-mp="27es2ayc8npsl">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-233" data-mp="2cewkcsssoskx" /> 7-Day
                Guarantee
              </li>
            </ul>
            <p className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-neutral-700" data-id="element-234" data-mp="2hcy4lh1yixxz">
              <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-235" data-mp="2mbj41e9dxdld" /> Card ·
              GooglePay · ApplePay
            </p>
          </div>
        </div>

        <p className="mt-6 text-center text-xs text-neutral-500" data-id="element-236" data-mp="2v5xhrce9og2d">
          💱 You'll be charged in your local currency
        </p>
      </div>
    </section>;
}